var _defs, _path, _path2, _path3, _path4, _rect, _path5, _polygon, _path6, _path7, _path8, _path9, _path10, _path11, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _circle;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 131.73 158.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#424379;}.c{fill:#999;}.d{fill:#c30d23;}.e{fill:#006934;}.f{fill:#f8b62d;}.g{fill:#0068b7;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M105.58,138a7.69,7.69,0,0,0-5.74,2.47,8.22,8.22,0,0,0-2.4,6,8.51,8.51,0,0,0,1.09,4.22,7.76,7.76,0,0,0,3,3,8.39,8.39,0,0,0,8.2,0,7.76,7.76,0,0,0,2.95-3,8.49,8.49,0,0,0,1.1-4.22,8.2,8.2,0,0,0-2.42-6A7.68,7.68,0,0,0,105.58,138Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M63.74,138.71a8.25,8.25,0,0,0-3.55-.79,7.55,7.55,0,0,0-5.26,2,8.42,8.42,0,0,0-2.22,3.63h15.1a8.42,8.42,0,0,0-1.37-2.75A7.36,7.36,0,0,0,63.74,138.71Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M17.49,146.7c-.19.43-.49.43-.67,0L5.38,120a1.4,1.4,0,0,0-1.19-.78H.58a.52.52,0,0,0-.52.78l16,37.2a1.34,1.34,0,0,0,1.11.78,1.36,1.36,0,0,0,1.12-.78L34.43,120a.52.52,0,0,0-.51-.78H30.31a1.43,1.43,0,0,0-1.2.78Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M40.39,125.46a2.81,2.81,0,0,0-2,.86,2.91,2.91,0,0,0,0,4.13,2.81,2.81,0,0,0,2,.86,2.93,2.93,0,0,0,0-5.85Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 38.4,
    y: 134.63,
    width: 3.99,
    height: 23.39
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M72.26,146.54a12.61,12.61,0,0,0-2.58-7.95,11.56,11.56,0,0,0-9.53-4.54,11.22,11.22,0,0,0-9.28,4.43,12.76,12.76,0,0,0,.49,16.34,11.23,11.23,0,0,0,9,3.77,12.88,12.88,0,0,0,4.61-.78,11.59,11.59,0,0,0,3.68-2.29,13.91,13.91,0,0,0,2.86-3.93l.26-.49-3.38-1.78-.27.46a13.12,13.12,0,0,1-2.33,3,8.36,8.36,0,0,1-2.56,1.46,9,9,0,0,1-3.12.56,7.3,7.3,0,0,1-5.51-2.31,8.34,8.34,0,0,1-2.3-5.41h20Zm-19.55-3a8.42,8.42,0,0,1,2.22-3.63,7.55,7.55,0,0,1,5.26-2,8.25,8.25,0,0,1,3.55.79,7.36,7.36,0,0,1,2.7,2,8.42,8.42,0,0,1,1.37,2.75Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "74.53 134.63 74.53 138.27 85.48 138.27 72.88 158.02 91.6 158.02 91.6 154.36 79.87 154.36 92.47 134.63 74.53 134.63"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M105.59,134.05a11.62,11.62,0,0,0-9,3.93,12.48,12.48,0,0,0,.17,16.94,12.34,12.34,0,0,0,17.56,0,12.52,12.52,0,0,0,.18-17A11.65,11.65,0,0,0,105.59,134.05Zm7,16.62a7.76,7.76,0,0,1-2.95,3,8.39,8.39,0,0,1-8.2,0,7.76,7.76,0,0,1-3-3,8.51,8.51,0,0,1-1.09-4.22,8.22,8.22,0,0,1,2.4-6,7.89,7.89,0,0,1,11.47,0,8.2,8.2,0,0,1,2.42,6A8.49,8.49,0,0,1,112.63,150.67Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M126.91,130a1,1,0,0,1,.45-.47,2.11,2.11,0,0,1,1.1-.26,6.53,6.53,0,0,1,2.48.63l.79.34v-4.08l-.41-.12a12.89,12.89,0,0,0-3.49-.59,5.46,5.46,0,0,0-2.84.7,4.11,4.11,0,0,0-1.72,1.91,9.74,9.74,0,0,0-.49,3.64v2.92h-2.92v3.6h2.92V158h4l0-19.79h4.65v-3.6h-4.65v-2.45A9.19,9.19,0,0,1,126.91,130Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M40.4,9.57a41,41,0,0,1-7.4,9.9c-3,3-5,4.23-6.3,4.75L51,34.67Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M108.13,23.87a40.76,40.76,0,0,1-9.92-7.41c-3-3-4.28-5.06-4.77-6.39L82.92,34.56Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M108.81,77.51,83,66.44,94,92.22a41.41,41.41,0,0,1,7.26-9.65C105.38,78.42,107.68,77.58,108.81,77.51Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M25.54,77.41a40,40,0,0,1,10.38,7.9,21.16,21.16,0,0,1,4.53,6.14l10.7-24.9Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "84.97 0 78.29 0 66.95 28.01 55.78 0 49.1 0 66.82 43.45 84.97 0"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "55.78 101.11 67.11 73.1 78.29 101.11 84.97 101.11 67.24 57.66 49.1 101.11 55.78 101.11"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "43.97 2.13 39.25 6.85 40.4 9.57 51.04 34.67 26.7 24.21 23.33 22.77 18.61 27.49 61.86 45.68 43.97 2.13"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "108.81 77.51 110.74 78.34 115.46 73.62 72.2 55.43 90.1 98.98 94.82 94.26 93.96 92.22 83.03 66.44 108.81 77.51"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "16.48 32.62 16.48 39.3 44.49 50.63 16.48 61.81 16.48 68.48 59.93 50.76 16.48 32.62"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "117.59 32.62 74.14 50.34 117.59 68.48 117.59 61.81 89.58 50.48 117.59 39.3 117.59 32.62"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "18.61 73.62 23.33 78.34 25.54 77.41 51.15 66.55 40.45 91.45 39.25 94.26 43.97 98.98 62.16 55.72 18.61 73.62"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "115.46 27.49 110.74 22.77 108.13 23.87 82.92 34.56 93.44 10.07 94.82 6.85 90.1 2.13 71.91 45.38 115.46 27.49"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 67.03,
    cy: 50.55,
    r: 3.51
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.578fb31aa9b5b61c90b6c6fceeadbf52.svg";
export { ForwardRef as ReactComponent };